import { render, staticRenderFns } from "./OrganizationAdminList.vue?vue&type=template&id=7fb4352b&scoped=true&"
import script from "./OrganizationAdminList.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAdminList.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationAdminList.vue?vue&type=style&index=0&id=7fb4352b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4352b",
  null
  
)

export default component.exports